const inDays = (n) => {
  const d = new Date();
  d.setDate(d.getDate() + n);
  return d.toISOString().slice(0, 10);
};

export const SAMPLES = [
  {
    id: "multa",
    label: "Verbale di multa",
    hint: "Divieto di sosta, Polizia Locale",
    result: {
      tipo_documento: "Verbale multa",
      titolo: "Multa per divieto di sosta",
      mittente: "Polizia Locale (esempio)",
      riassunto: "È un verbale per sosta vietata. Puoi pagare con lo sconto del 30% se paghi entro 5 giorni dalla notifica, oppure fare ricorso se ritieni la multa ingiusta.",
      urgenza: "alta",
      importo: "42,00 €",
      cosa_fare: [
        "Controlla targa, data, luogo e che il verbale ti sia stato notificato correttamente.",
        "Se è corretto, paga entro 5 giorni dalla notifica per avere lo sconto del 30%: usa il codice pagoPA sul verbale.",
        "Se non sei d'accordo, puoi fare ricorso al Prefetto o al Giudice di pace entro i termini indicati nel verbale.",
        "Conserva la ricevuta di pagamento insieme al verbale.",
      ],
      scadenze: [{ titolo: "Pagamento multa con sconto", data: inDays(5) }, { titolo: "Termine per il ricorso", data: inDays(30) }],
      fai_da_te: "Sì: il pagamento si fa in 2 minuti dall'app della banca o su pagopa.gov.it con il codice avviso.",
      serve_caf: "Per il ricorso, se la questione è complessa, conviene farsi aiutare da un'associazione consumatori o da un professionista.",
      link_utili: [{ nome: "pagoPA", url: "https://www.pagopa.gov.it" }],
      guida_correlata: "multa",
      attenzione: "Il termine dei 5 giorni per lo sconto parte dalla data di notifica, non da quella della multa.",
    },
  },
  {
    id: "cartella",
    label: "Cartella esattoriale",
    hint: "Agenzia delle Entrate-Riscossione",
    result: {
      tipo_documento: "Cartella esattoriale",
      titolo: "Cartella di pagamento",
      mittente: "Agenzia delle Entrate-Riscossione (esempio)",
      riassunto: "È una cartella di pagamento per un importo non pagato. Hai 60 giorni dalla notifica per pagare, chiedere la rateizzazione o verificare se è corretta.",
      urgenza: "alta",
      importo: "618,35 €",
      cosa_fare: [
        "Verifica di che tributo si tratta e a quale anno si riferisce.",
        "Accedi all'area riservata di Agenzia delle Entrate-Riscossione con SPID o CIE per vedere il dettaglio.",
        "Se non puoi pagare tutto, chiedi la rateizzazione online.",
        "Se pensi che sia sbagliata, puoi chiedere una verifica all'ente che ha emesso il debito.",
      ],
      scadenze: [{ titolo: "Pagamento o rateizzazione cartella", data: inDays(60) }],
      fai_da_te: "Sì: pagamento e rateizzazione si fanno online sul sito di Agenzia delle Entrate-Riscossione.",
      serve_caf: "Se la cartella è vecchia o pensi che il debito sia prescritto, chiedi un parere a un CAF o a un professionista.",
      link_utili: [{ nome: "Agenzia delle Entrate-Riscossione", url: "https://www.agenziaentrateriscossione.gov.it" }],
      guida_correlata: null,
      attenzione: "Non ignorarla: dopo i 60 giorni possono partire interessi di mora e azioni di recupero.",
    },
  },
  {
    id: "tari",
    label: "Avviso TARI",
    hint: "Tassa sui rifiuti del Comune",
    result: {
      tipo_documento: "Avviso di pagamento PagoPA",
      titolo: "Avviso di pagamento TARI",
      mittente: "Comune (esempio)",
      riassunto: "È l'avviso della tassa rifiuti. Puoi pagarla in un'unica soluzione o nelle rate indicate, con i bollettini pagoPA allegati.",
      urgenza: "media",
      importo: "214,00 €",
      cosa_fare: [
        "Controlla che i metri quadri e il numero di persone in casa siano corretti.",
        "Paga con il codice pagoPA dall'app della banca, in tabaccheria o alle Poste.",
        "Se i dati sono sbagliati, contatta l'ufficio tributi del tuo Comune prima della scadenza.",
        "Salva la ricevuta nell'Archivio.",
      ],
      scadenze: [{ titolo: "Pagamento TARI", data: inDays(45) }],
      fai_da_te: "Sì: 5 minuti, gratis, con pagoPA.",
      serve_caf: "Di solito non serve.",
      link_utili: [{ nome: "pagoPA", url: "https://www.pagopa.gov.it" }],
      guida_correlata: null,
      attenzione: null,
    },
  },
];
